import React, { useCallback } from 'react';
import type { Tenant } from '#/graphql/types';
import { useNavigate } from 'react-router-dom';
import List from '#/common/components/List';
import { getTenantList } from '#/graphql/queries';
import { gql } from '@apollo/client';
import { Filter } from '#/common/components/DataGrid';

const getTenantListQuery = gql(getTenantList);

export interface TenantListProps {
  permanentFilters?: Filter[];
}

const TenantList: React.FC<TenantListProps> = (props) => {
  const { permanentFilters } = props;

  const navigate = useNavigate();

  const openTenant = useCallback(
    (tenant: Tenant) => {
      navigate(`/tenants/${tenant.id}`);
    },
    [navigate],
  );

  return (
    <List<Tenant>
      titleKey="name"
      subtitleKey="address"
      onClick={openTenant}
      getItemsQuery={getTenantListQuery}
      permanentFilters={permanentFilters}
      bodyFields={[
        { key: 'tisId', label: 'TIS ID' },
        { key: 'plan', label: 'Plan' },
      ]}
    />
  );
};

export default React.memo(TenantList);
